import React, { useContext, useEffect, useRef } from 'react';
import { AuthContext } from '../context/AuthContext';
import { ChatContext } from '../context/ChatContext';

const Message = ({ message }) => {
  const { currentUser } = useContext(AuthContext);
  const { data } = useContext(ChatContext);
  const ref = useRef();

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [message]);

  const renderFileMessage = (file, fileType) => {
    switch (fileType) {
      case 'pdf':
        return <a href={file} target="_blank" rel="noopener noreferrer">View PDF</a>;
      case 'doc':
      case 'docx':
        return <a href={file} target="_blank" rel="noopener noreferrer">View Document</a>;
      case 'xls':
      case 'xlsx':
        return <a href={file} target="_blank" rel="noopener noreferrer">View Spreadsheet</a>;
      case 'ppt':
      case 'pptx':
        return <a href={file} target="_blank" rel="noopener noreferrer">View Presentation</a>;
      default:
        return <a href={file} target="_blank" rel="noopener noreferrer">Download File</a>;
    }
  };

  const isOwner = message.senderId === currentUser.uid;

  return (
    <div ref={ref} className={`chat-bubble-wrapper ${isOwner ? "chat-bubble-wrapper--sent" : "chat-bubble-wrapper--received"}`}>
      {!isOwner && (
        <img src={data.user.photoURL} alt="" className="chat-bubble__avatar" />
      )}
      
      <div className={`chat-bubble ${isOwner ? "chat-bubble--sent" : "chat-bubble--received"}`}>
        {message.img && (
          <a href={message.img} target="_blank" rel="noopener noreferrer" download>
            <img src={message.img} alt="" className="chat-bubble__image" />
          </a>
        )}
        
        {message.text && <p className="chat-bubble__text">{message.text}</p>}
        
        {message.audio && (
          <audio controls className="chat-bubble__media">
            <source src={message.audio} type="audio/mpeg" />
          </audio>
        )}
        
        {message.file && (
          <div className='chat-bubble__file'>
            {renderFileMessage(message.file, message.fileType)}
          </div>    
        )}
        
        {message.video && (
          <video controls className="chat-bubble__media">
            <source src={message.video} type="video/mp4" />
          </video>
        )}
        
        <div className="chat-bubble__meta">
          <span className="chat-bubble__time">Just now</span>
          {isOwner && (
            <span className="chat-bubble__ticks">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L9 17L20 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Message;
